import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import PressStrip from './components/PressStrip';
import HowItWorks from './components/HowItWorks';
import Cities from './components/Cities';
import FareEstimator from './components/FareEstimator';
import Faces from './components/Faces';
import Testimonials from './components/Testimonials';
import Safety from './components/Safety';
import Sustainability from './components/Sustainability';
import DriveWithUs from './components/DriveWithUs';
import Contact from './components/Contact';
import GetTheApp from './components/GetTheApp';
import Faqs from './components/Faqs';
import Footer from './components/Footer';
import BookRideModal from './components/BookRideModal';
import './App.css';

function App() {
  const [bookOpen, setBookOpen] = useState(false);

  const scrollToDrive = () => {
    const el = document.getElementById('drive');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="min-h-screen bg-white text-[#0f0f10] font-sans antialiased selection:bg-[#FF6A1A] selection:text-white">
      <Header onBookRide={() => setBookOpen(true)} onDriveWithUs={scrollToDrive} />
      <main id="top">
        <Hero onBookRide={() => setBookOpen(true)} onDriveWithUs={scrollToDrive} />
        <PressStrip />
        <HowItWorks />
        <Cities />
        <FareEstimator />
        <Faces onBookRide={() => setBookOpen(true)} />
        <Testimonials />
        <Safety />
        <Sustainability />
        <DriveWithUs />
        <Contact />
        <Faqs />
        <GetTheApp />
      </main>
      <Footer />
      <BookRideModal open={bookOpen} onClose={() => setBookOpen(false)} />
    </div>
  );
}

export default App;
